import { render, staticRenderFns } from "./ExpiredState.vue?vue&type=template&id=4575838a&"
import script from "./ExpiredState.vue?vue&type=script&lang=js&"
export * from "./ExpiredState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports